import { Injectable } from '@angular/core';
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {UserBlockedModalComponent} from "../../../components/user-blocked-modal/user-blocked-modal.component";

@Injectable({
  providedIn: 'root'
})
export class UserBlockedService {

  private modalRef!: NgbModalRef;
  translations: any

  constructor(
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig
    ) {
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = false;
  }

  open(translations: any) {
    this.modalRef = this.modalService.open(UserBlockedModalComponent);
    this.modalRef.componentInstance.translations = translations
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  getTranslations() {
    return this.translations
  }

  setTranslations(value: any) {
    this.translations = value
  }
}
